<div modeNotebookResizeCells>
  <ng-content></ng-content>
</div>
